import * as MobX from "mobx";
import { BaseStore } from "@shoothill/core";
import { Stores } from "../Stores";
import { InitialState } from "Globals/Models";
import { ApplicationFormStatus } from "Globals/Models";

export class ApplicationFormStatusStore extends BaseStore {
    public constructor() {
        super();
    }

    @MobX.observable private allPayToken: string = "test";
    @MobX.observable private ApplicationFormStatus: ApplicationFormStatus[] = [];

    public init(stores: Stores, initialState: InitialState) {
        this.ApplicationFormStatus = initialState.applicationFormStatus;
    }
    public getStatus = (statusId: string): ApplicationFormStatus | undefined => {
        return this.ApplicationFormStatus.find((s) => s.id == statusId);
    };
    public getStatusName = (statusId: string): string => {
        let status = this.ApplicationFormStatus.find((s) => s.id == statusId);
        return status ? status.name : "Status Name Not Found";
    };
    public getApplicationFormStatus = (): ApplicationFormStatus[] => {
        return this.ApplicationFormStatus;
    };

    @MobX.action
    public setAllPayToken = (value: string): void => {
        //debugger;
        this.allPayToken = value;
    };

    @MobX.computed
    public get getAllPayToken() {
        //debugger;
        return this.allPayToken;
    }
}
